import { useState } from "react";
import { useLocation } from "react-router";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import useUser from "@auth/user/useUser";
import { useVerificaMenuRouteGuard } from "@/permissoes/hooks/usePermissoes";
import { APP_ROUTES } from "@/configs/configRotas/app-rotas.constants";
import { obterTagPorUrl } from "@/configs/configRotas/app-rotas.utils";
import RestricoesRecursoModal from "./restricoesRecursoModal/ui/RestricoesRecursoModal";

type RestricoesRecursoButtonProps = {
	readonly className?: string;
};

const TAG_RESTRICOES = APP_ROUTES.configGeral.restricoes.tag;

/**
 * Botão (ícone shield) no header que abre o modal de restrições da tela atual.
 * Só aparece quando a tela atual tem `tag` e o usuário tem acesso a `seguranca.restricoes`
 * (verificado via `menu/verificar-acesso`). Usuário Space tem bypass.
 */
export default function RestricoesRecursoButton({ className = "" }: RestricoesRecursoButtonProps) {
	const { data: user } = useUser();
	const isSpaceUser = Boolean(user?.eh_usuario_space);
	const location = useLocation();
	const tagRecurso = obterTagPorUrl(location.pathname);

	const [aberto, setAberto] = useState(false);

	const { isSuccess } = useVerificaMenuRouteGuard(TAG_RESTRICOES, !isSpaceUser && Boolean(tagRecurso), true);
	const permitido = isSpaceUser || isSuccess;

	if (!tagRecurso || !permitido) return null;

	return (
		<>
			<Tooltip title="Restrições da tela" placement="bottom">
				<IconButton
					size="small"
					className={className}
					aria-label="Restrições da tela"
					onClick={() => setAberto(true)}
					disabled={tagRecurso === TAG_RESTRICOES}
				>
					<FuseSvgIcon>lucide:shield</FuseSvgIcon>
				</IconButton>
			</Tooltip>

			<RestricoesRecursoModal aberto={aberto} tagRecurso={tagRecurso} onFechar={() => setAberto(false)} />
		</>
	);
}
